import { useEffect, useState } from "react";

/**
 * Which Daily work layout fits the screen: a list on phones and small tablets, the list beside the
 * loom page from 900px (iPad landscape), the full table from 1200px. 900 rather than 768 because the
 * list needs ~300px next to a usable loom page; portrait tablets get the roomier list.
 */
export type WidthTier = "list" | "split" | "table";

const SPLIT = "(min-width: 900px)";
const TABLE = "(min-width: 1200px)";

const read = (): WidthTier => {
  if (typeof window === "undefined" || !window.matchMedia) return "list";
  if (window.matchMedia(TABLE).matches) return "table";
  if (window.matchMedia(SPLIT).matches) return "split";
  return "list";
};

export const useWidthTier = (): WidthTier => {
  const [tier, setTier] = useState<WidthTier>(read);
  useEffect(() => {
    if (!window.matchMedia) return;
    const queries = [window.matchMedia(SPLIT), window.matchMedia(TABLE)];
    const on = () => setTier(read());
    queries.forEach((q) => (q.addEventListener ? q.addEventListener("change", on) : q.addListener(on)));
    return () => queries.forEach((q) => (q.removeEventListener ? q.removeEventListener("change", on) : q.removeListener(on)));
  }, []);
  return tier;
};
